import * as types from './kpi.types';

export const kpiPageSelectors: types.IKpiPageSelectors = {
  selectKpiRowIds: (state) => state.page.kpi.kpiRowIds,
  selectSessionIds: (state) => state.page.kpi.sessionIds,
  selectScoreIds: (state) => state.page.kpi.scoreIds,
  selectIsFiltered: (state) => state.page.kpi.isFiltered,
};
